import React, { useState, useEffect } from 'react';
import VacancyDetail from '../../services/vacancy.service';
import './VacancyDetails.css';

const VacancyDetails = () => {
  const [vacancies, setVacancies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(4);
  const [selectedVacancy, setSelectedVacancy] = useState(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchVacancies = async () => {
      try {
        const data = await VacancyDetail.getAllVacancies(token);
        const currentDate = new Date();
        const activeVacancies = data.data.filter(vacancy => {
          const endDate = new Date(vacancy.end_date);
          return !isNaN(endDate) && endDate >= currentDate;
        });
        setVacancies(activeVacancies);
      } catch (error) {
        console.error('Error fetching vacancies:', error);
      }
    };
    fetchVacancies();
  }, [token]);

  const indexOfLastRecord = Math.min(currentPage * recordsPerPage, vacancies.length);
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = vacancies.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(vacancies.length / recordsPerPage);

  const renderPagination = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
    return (
      <div className="pagination">
        {pageNumbers.map((pageNumber) => (
          <button
            key={pageNumber}
            className={currentPage === pageNumber ? 'active' : ''}
            onClick={() => setCurrentPage(pageNumber)}
          >
            {pageNumber}
          </button>
        ))}
      </div>
    );
  };

  const handleVacancyClick = (vacancy) => {
    setSelectedVacancy(vacancy);
  };

  const closeModal = () => {
    setSelectedVacancy(null);
  };

  const handleEdit = () => {
    console.log('Edit vacancy:', selectedVacancy);
  };

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this vacancy?')) {
      try {
        await VacancyDetail.deleteVacancy(selectedVacancy.vacancy_id, token);
        setVacancies(vacancies.filter(v => v.vacancy_id !== selectedVacancy.vacancy_id));
        closeModal();
      } catch (error) {
        console.error('Error deleting vacancy:', error);
      }
    }
  };

  return (
    <div className="table-container">
      {vacancies.length > 0 ? (
        <div>
          <table>
            <thead>
              <tr>
                <th className="hide-mobile">Vacancy ID</th>
                <th>Position</th>
                <th className="hide-mobile">Educational Qualification</th>
                <th className="hide-mobile">Place of Work</th>
                <th>Link</th>
                <th className="hide-mobile">Required Number</th>
                <th className="hide-mobile">End Date</th>
              </tr>
            </thead>
            <tbody>
              {currentRecords.map((vacancy, index) => (
                <tr key={vacancy.vacancy_id} onClick={() => handleVacancyClick(vacancy)}>
                  <td className="hide-mobile">{index + 1}</td>
                  <td>{vacancy.title}</td>
                  <td className="hide-mobile">{vacancy.description}</td>
                  <td className="hide-mobile">{vacancy.location}</td>
                  <td>
                    <a href={vacancy.link} target="_blank" rel="noopener noreferrer">
                      {vacancy.link}
                    </a>
                  </td>
                  <td className="hide-mobile">{vacancy.salary}</td>
                  <td className="hide-mobile">
                    {new Date(vacancy.end_date).toLocaleDateString('en-GB', {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric',
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {renderPagination()}
        </div>
      ) : (
        <h1 className="no-vacancy">No Vacancy</h1>
      )}

      {selectedVacancy && (
        <div className="modal">
          <div className="modal-content">
            <h2>Vacancy Details</h2>
            <p><strong>Position:</strong> {selectedVacancy.title}</p>
            <p><strong>Educational Qualification:</strong> {selectedVacancy.description}</p>
            <p><strong>Place of Work:</strong> {selectedVacancy.location}</p>
            <p><strong>Job Type:</strong> {selectedVacancy.job_type}</p>
            <p><strong>Experience:</strong> {selectedVacancy.requirements}</p>
            <p><strong>Link:</strong> <a href={selectedVacancy.link}>{selectedVacancy.link}</a></p>
            <p><strong>Required Number:</strong> {selectedVacancy.salary}</p>
            <p><strong>End Date:</strong> {new Date(selectedVacancy.end_date).toLocaleDateString('en-GB')}</p>
            {token && (
              <div>
                <button onClick={handleEdit}>Edit</button>
                <button onClick={handleDelete}>Delete</button>
              </div>
            )}
            <button onClick={closeModal}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};
export default VacancyDetails;